module KendoWidgets
{
	export class TreeGridOptions
	{
		columns: TreeGridColumn[];
		dataSource?: TreeGridElement[];
		width?: number | string;
		height?: number; // Calculated properties and such wouldn't work anyways
		fontSize?: number | string;
		headerFontSize?: number | string;

		/** The space to leave below the tree grid. If set, the height is calculated automatically. */
		leaveSpaceBelow?: number;

		exportOptions?: {
			fileName: string,
			sheetName?: string
		}
	}

	export class TreeGrid extends kendo.ui.Widget implements KendoWidget
	{
		private _dataSource: TreeGridElement[] | null;
		public options: TreeGridOptions;

		controlType(): ControlTypeEnum { return ControlTypeEnum.TreeGrid; }

		constructor(element: Element, options?: KendoWidgets.TreeGridOptions)
		{
			if (options == null)
				options = new KendoWidgets.TreeGridOptions;

			super(element, options);

			this.options = options;

			if (options.dataSource == null)
				options.dataSource = [];
			this.dataSource(options.dataSource);
		}

		dataSource(dataSource?: TreeGridElement[] | null): TreeGridElement[] | null
		{
			if (typeof (dataSource) != "undefined")
			{
				this._dataSource = dataSource;
				this.redraw();
			}
			return this._dataSource;
		}

		private redraw()
		{
			// Remove existing children
			$(this.element).children().remove();

			let totalNestingLevel = this.findNestingLevel();

			//#region Main table
			let table = $("<table class='treegrid'>").appendTo(this.element)[0] as HTMLTableElement;
			if (this.options.width != null)
			{
				if (typeof (this.options.width) == "number")
					table.style.width = this.options.width.toString() + "px";
				else table.style.width = this.options.width;
			}
			//#endregion

			//#region Fake header
			let colHeaders: Map<string, HTMLTableHeaderCellElement> = new Map<string, HTMLTableHeaderCellElement>();

			let thead = document.createElement("thead");
			table.appendChild(thead);
			let headerRow = $("<tr class='treegrid-header'>").appendTo(thead)[0] as HTMLTableRowElement;

			// Find the main column
			let mainCol = this.options.columns[0];

			let th = this.generateColumnHeader(mainCol, totalNestingLevel, true, this._dataSource == null || this._dataSource.length == 0);
			headerRow.appendChild(th);

			colHeaders.set(mainCol.name, th);

			// Other columns
			for (let i = 1; i < this.options.columns.length; i++)
			{
				let column = this.options.columns[i];

				let th = this.generateColumnHeader(column);
				headerRow.appendChild(th);

				colHeaders.set(column.name, th);
			}
			//#endregion
			
			//#region Body
			let tbody = document.createElement("tbody");
			table.appendChild(tbody);

			let fontSize: string;
			if (this.options.fontSize == null)
				fontSize = "12px";
			else
			{
				if (typeof (this.options.fontSize == "number"))
					fontSize = this.options.fontSize!.toString() + "px";
				else fontSize = this.options.fontSize! as string;
			}
			$(tbody).css("font-size", fontSize);

			if (this._dataSource == null || this._dataSource.length == 0)
			{
				let tr = this.generateRow(table, null, 0, totalNestingLevel)[0];
				tbody.appendChild(tr);
			}
			else
			{
				for (let row of this._dataSource)
				{
					let trs = this.generateRow(table, row, 0, totalNestingLevel);
					for (let tr of trs)
						tbody.appendChild(tr);
				}
			}
			//#endregion

			//#region Real header
			let realHeaderTable = $("<table class='treegrid treegrid-realheader'>").prependTo(this.element)[0] as HTMLTableElement;
			realHeaderTable.style.widows = table.style.width;
			realHeaderTable.style.margin = table.style.margin;
			let realHeader = document.createElement("thead");
			realHeaderTable.appendChild(realHeader);

			let headerFontSize: string;
			if (this.options.headerFontSize == null)
				headerFontSize = "20px";
			else
			{
				if (typeof (this.options.headerFontSize == "number"))
					headerFontSize = this.options.headerFontSize.toString() + "px";
				else headerFontSize = this.options.headerFontSize as string;
			}

			let realTr = $("<tr class='treegrid-header' style='font-size: " + headerFontSize + "'>").appendTo(realHeader)[0] as HTMLTableRowElement;

			// Get widths
			let first = true;
			for (let pair of colHeaders)
			{
				let th = colHeaders.get(pair[0])!
				let width = parseInt(window.getComputedStyle(th).width!)

				let newTh = $("<th colspan='" + th.colSpan + "'>" + th.innerHTML + "</th>").appendTo(realTr)[0] as HTMLTableHeaderCellElement;
				if (th.classList.contains("treegrid-value"))
					newTh.classList.add("treegrid-value");
				newTh.style.width = width.toString() + "px";

				if (first)
				{
					$("<button id='" + this.element[0].id + "_btnExport' class='treegrid-export'>").prependTo(newTh).kendoButton(<KendoWidgets.ButtonOptions>{
						labelText: "Excel",
						icon: IconClass.Excel,
						click: _ => this.export()
					});
					first = false;
				}
			}

			// Hide header
			$(thead).css("visibility", "collapse");
			//#endregion

			//#region Style the container
			$(this.element).css("overflow-y", "auto");

			if (this.options.height != null)
				$(this.element).css("height", this.options.height.toString() + "px");

			if (this.options.leaveSpaceBelow != null)
			{
				this.element.each((_, elem) =>
				{
					this.setElementAutoHeight(elem);

					$(window).resize(() => this.setElementAutoHeight(elem));
				});
			}
			//#endregion
		}

		private setElementAutoHeight(elem: Element)
		{
			let top = elem.getBoundingClientRect().top;
			let height = window.innerHeight;
			let available = height - top - this.options.leaveSpaceBelow!;

			$(elem).css("height", available);
		}

		refreshHeight()
		{
			this.element.each((_, elem) => this.setElementAutoHeight(elem));
		}

		private generateColumnHeader(col: TreeGridColumn, nestingLevel?: number, main: boolean = false, emptyDataSource: boolean = false): HTMLTableHeaderCellElement
		{
			let th = document.createElement("th");
			if (nestingLevel != null && main)
				th.colSpan = nestingLevel + 1 + (emptyDataSource && (nestingLevel == 0) ? 1 : 0);
			else
			{
				th.classList.add("treegrid-value");
				if (col.width != null)
				{
					if (typeof (col.width) == "number")
						th.style.width = col.width.toString() + "px";
					else th.style.width = col.width;
				}
			}
			th.textContent = col.title;

			return th;
		}

		private generateRow(table: HTMLTableElement, row: TreeGridElement | null, nestingLevel: number, totalNesting: number, showNoDataText: boolean = true): HTMLTableRowElement[]
		{
			let tr = $("<tr>")[0] as HTMLTableRowElement;
			let trs = [tr];

			let fillers = nestingLevel;
			let isLeaf = false;

			// Nesting fillers
			for (let i = 0; i < fillers; i++)
				$("<td class='treegrid-filler'>").appendTo(tr);

			// Expander
			let expander: HTMLTableDataCellElement | null = null;
			if (row != null && row.children != null && row.children.length > 0)
				expander = $("<td class='treegrid-expander'>").appendTo(tr)[0] as HTMLTableCellElement;
			else //if (row != null)
			{
				$("<td class='treegrid-filler'>").appendTo(tr);
				isLeaf = true;
			}

			// Text
			let colspan = totalNesting - nestingLevel;
			let textCell: HTMLTableDataCellElement;
			if (row != null)
				textCell = $("<td colspan='" + colspan.toString() + "'>" + row.text + "</td>").appendTo(tr)[0] as HTMLTableDataCellElement;
			else textCell = $("<td colspan='" + colspan.toString() + "' class='treegrid-empty'>" + (showNoDataText ? "Nessun dato trovato" : "&nbsp;") + "</td>").appendTo(tr)[0] as HTMLTableDataCellElement;

			let fontWeight = 400;
			if (isLeaf)
			{
				let column = this.options.columns[0];
				if (column.width != null)
				{
					if (typeof (column.width) == "number")
						textCell.style.width = column.width.toString() + "px";
					else textCell.style.width = column.width;
				}
			}
			else fontWeight += colspan * 150;

			let children: HTMLTableRowElement[] = [];

			for (let column of this.options.columns)
			{
				let valueClass = (this._dataSource == null || this._dataSource.length == 0) ? 'treegrid-filler' : 'treegrid-value';

				if (row == null)
				{
					if (column != this.options.columns[0])
						$("<td class='" + valueClass + "' style='font-weight:" + fontWeight.toString() + "'></td>").appendTo(tr);
				}
				else
				{
					let cells = row.data.filter(k => k.columnName == column.name);
					if (cells.length > 0)
					{
						let cell = cells[0];

						let valueString: string;
						if (column.template != null)
							valueString = column.template(cell.value);
						else if (column.format != null)
						{
							let num = parseFloat(cell.value);
							if (isNaN(num))
							{
								// Suppose it's a date
								let date = Date.parse(cell.value)
								valueString = kendo.toString(date, column.format);
							}
							else
								valueString = kendo.toString(num, column.format);
						}
						else
						{
							switch (column.type)
							{
								case KendoWidgets.TreeGridColumnType.String:
								case KendoWidgets.TreeGridColumnType.Custom:
								default:
									valueString = cell.value;
									break;
								case KendoWidgets.TreeGridColumnType.Integer:
									let num = parseInt(cell.value);
									valueString = kendo.toString(num, "N0");
									break;
								case KendoWidgets.TreeGridColumnType.Decimal:
									let dec = parseFloat(cell.value);
									valueString = kendo.toString(dec, "N2");
									break;
								case KendoWidgets.TreeGridColumnType.Currency:
									let cur = parseFloat(cell.value);
									valueString = kendo.toString(cur, "C2");
									break;
								case KendoWidgets.TreeGridColumnType.Percentage:
									let perc = parseFloat(cell.value);
									valueString = kendo.toString(perc, "P2");
									break;
								case KendoWidgets.TreeGridColumnType.Boolean:
									let b = Boolean(cell.value);
									valueString = b ? "Sì" : "No";
									break;
							}
						}

						$("<td class='" + valueClass + "' style='font-weight:" + fontWeight.toString() + "'>" + valueString + "</td>").appendTo(tr);
					}
				}
			}

			if (row != null)
			{
				// Nested rows
				if (row.children != null && row.children.length > 0)
				{
					for (let i = 0; i < row.children.length; i++)
					{
						let nested = row.children[i];
						for (let tr of this.generateRow(table, nested, nestingLevel + 1, totalNesting))
						{
							children.push(tr);
							trs.push(tr);
						}
					}

					let separator = this.generateRow(table, null, nestingLevel, totalNesting, false)[0];
					children.push(separator);
					trs.push(separator);
				}
			}

			// Click
			if (expander != null)
			{
				$(expander).on("click", () =>
				{
					let expanded = $(children[0]).is(":visible");
					if (expanded)
					{
						expander!.classList.remove("treegrid-expander");
						expander!.classList.add("treegrid-expander-collapsed");
					}
					else
					{
						expander!.classList.remove("treegrid-expander-collapsed");
						expander!.classList.add("treegrid-expander");
					}

					for (let child of children)
					{
						if (expanded)
							$(child).hide();
						else
						{
							$(child).show();

							// Reopen all the expanders below
							$(child).find(".treegrid-expander-collapsed").each((_, elem) =>
							{
								elem.classList.remove("treegrid-expander-collapsed");
								elem.classList.add("treegrid-expander");
							})
						}
					}
				});
			}

			return trs;
		}

		private findNestingLevel(fromParent?: TreeGridElement): number
		{
			if (this._dataSource == null)
				return 0;

			if (fromParent == null)
			{
				let max = 0;
				for (let parent of this._dataSource)
				{
					let val = this.findNestingLevel(parent);
					if (val > max)
						max = val;
				}
				return max;
			}
			else if (fromParent.children == null || fromParent.children.length == 0)
				return 1;
			else
			{
				let max = 0;
				for (let child of fromParent.children)
				{
					let val = this.findNestingLevel(child);
					if (val > max)
						max = val;
				}
				return max + 1;
			}
		}

		setColumnTitle(columnName: string, title: string, redraw: boolean = false)
		{
			let cols = this.options.columns.filter(k => k.name == columnName);
			if (cols.length > 0)
			{
				let col = cols[0];
				col.title = title;
			}

			if (redraw)
				this.redraw();
		}

		private export()
		{
			let fileName: string | null = null;
			let sheetName: string | null = null;

			if (this.options.exportOptions != null)
			{
				fileName = this.options.exportOptions.fileName;
				if (this.options.exportOptions.sheetName != null)
					sheetName = this.options.exportOptions.sheetName;
			}

			let json = {
				AuthKey: "g7ybng?HAdk#Ld8U",
				dataSource: this._dataSource,
				columns: this.options.columns,
				fileName: fileName,
				sheetName: sheetName
			};

			let jsonS = JSON.stringify(json);

			$.ajax({
				method: "POST",
				url: "/api/TreeGridWebApi/ExportExcel",
				data: jsonS,
				dataType: "json",
				contentType: "application/json",
				processData: false,
				success: (data, status, x) =>
				{
					if (data.OK)
					{
						let url = data.downloadUrl;
						window.location.replace(url);
					}
					else
					{
						let error = data.Exception;
						
						if (error != null)
							kendo.alert(error.Message);
					}
				}
			})
		}
	}

	export class TreeGridElement
	{
		text: string; // Element text
		data: TreeGridCellData[]; // Column values
		children?: TreeGridElement[]; // Children
	}

	export class TreeGridCellData
	{
		columnName: string;
		value: any;
	}

	export class TreeGridColumn
	{
		title: string;
		name: string;
		type: TreeGridColumnType;
		decimals?: number;
		width?: number | string;
		format?: string;
		/**
		 * NOTE: If a template is specified, the format property is ignored.
		 */
		template?: (value: string) => string;
	}

	export enum TreeGridColumnType
	{
		String = 1,
		Integer = 2,
		Decimal = 3,
		Currency = 4,
		Percentage = 5,
		DateTime = 6,
		Boolean = 7,
		Custom = 8
	}

	TreeGrid.fn = TreeGrid.prototype;
	TreeGrid.fn.options = $.extend(true, {}, kendo.ui.Widget.fn.options);
	TreeGrid.fn.options.name = "TreeGrid";
	kendo.ui.plugin(TreeGrid);
}

interface JQuery
{
	kendoTreeGrid(options?: KendoWidgets.TreeGridOptions): JQuery;
	data(key: "kendoTreeGrid"): KendoWidgets.TreeGrid;
}